import React from "react";
import styles from "./mini.module.css";
import rightIconSrc from "../../assets/img/mini/right_icon.png";
import trialVersionCodeSrc from "../../assets/img/mini/trial_version_code.png";
import {Space} from "antd"
import {downloadLink} from "../../constants";
import {footerCustomerCode, homePhoneMini, miniAppProcess, miniSellGoods_1,
    miniSellGoods_2, miniSellGoods_3, miniWebUi, miniFunds, miniBg1, miniBg2} from "../../OSSPictureResource";
import {useLocation} from "react-router-dom";

const MiniSection: React.FC = () => {
    const intervalRef = React.useRef<number>();
    const [miniContentIndex, setMiniContentIndex] = React.useState(0);
    const style = {
        backgroundImage: `url(${miniBg1})`
    }

    const miniTipPic = React.useMemo(() => {
        if (miniContentIndex === 0) {
            return homePhoneMini;
        } else if (miniContentIndex === 1) {
            return miniWebUi;
        } else {
            return miniFunds;
        }
    }, [miniContentIndex]);

    React.useEffect(() => {
        intervalRef.current = window.setInterval(() => {
            setMiniContentIndex((index) => {
                if (index === 2) {
                    return 0;
                } else {
                    return index + 1;
                }
            });
        }, 3000);
        return () => {
            window.clearInterval(intervalRef.current);
        };
    }, []);

    const onClick = (index: number) => {
        window.clearInterval(intervalRef.current);
        setMiniContentIndex(index);
    }
    return (
        <div className={styles.miniSection} style={style}>
            <div className={styles.miniContent}>
                <div className={styles.miniContentList}>
                    <div className={styles.miniTitle}>Spaicn专属小程序</div>
                    <div
                        className={`${styles.miniContentItem} ${miniContentIndex === 0 && styles.miniContentItemActive}`}
                        onClick={() => onClick(0)}>
                        <Space>
                            <div className={styles.divide}/>
                            <div>
                                <div className={styles.miniContentItemTitle}>独立专属的小程序</div>
                                <div className={styles.miniContentItemTips}>
                                    帮助用户更好地了解企业的品牌形象、经营范围；树立企业的专业形象，提升品牌的信任度和忠诚度
                                </div>
                            </div>
                        </Space>
                    </div>
                    <div
                        className={`${styles.miniContentItem} ${miniContentIndex === 1 && styles.miniContentItemActive}`}
                        onClick={() => onClick(1)}>
                        <Space>
                            <div className={styles.divide}/>
                            <div>
                                <div className={styles.miniContentItemTitle}>灵活自由的页面</div>
                                <div className={styles.miniContentItemTips}>
                                    平台提供了一系列丰富的组件装饰，能够简单方便进行堆积木式组装；打造符合企业形象的个性化页面，提高美观度、可读性和使用价值
                                </div>
                            </div>
                        </Space>
                    </div>
                    <div
                        className={`${styles.miniContentItem} ${miniContentIndex === 2 && styles.miniContentItemActive}`}
                        onClick={() => onClick(2)}>
                        <Space>
                            <div className={styles.divide}/>
                            <div>
                                <div className={styles.miniContentItemTitle}>安全的资金流向</div>
                                <div className={styles.miniContentItemTips}>
                                    交易资金直接打入商家的微信支付账户，平台没有接触资金；不仅具有资金安全性，而且让买家拥有高效、便捷的支付体验
                                </div>
                            </div>
                        </Space>
                    </div>
                </div>
            </div>
            {miniContentIndex === 0 && <img className={styles.phoneIcon} src={miniTipPic} alt=""/>}
            {miniContentIndex !== 0 && <img className={styles.miniTipPic} src={miniTipPic} alt=""/>}
        </div>
    )
}
const AppProcessSection: React.FC = () => {
    return (
        <div className={styles.appProcessSection} id="part3">
            <div className={styles.appProcessTitle}>申请流程</div>
            <div className={styles.appProcessContent}>
                <img src={miniAppProcess} alt=""/>
            </div>
        </div>
    )
}
const SpaceSection: React.FC = () => {
    const style = {
        backgroundImage: `url(${miniBg2})`
    }
    const [index, setIndex] = React.useState(0);
    const data = React.useMemo(() => {
        if (index === 0) {
            return ["01 商家卖货", "商家在小程序上架设产品并进行销售，为买家提供方便快捷的购物服务"]
        } else if (index === 1) {
            return ["02 文档管理", "帮助商家更好地处理、管理和展现各种类型的内容，为读者带来极大的便利性"]
        } else {
            return ["03 营销活动", "可以吸引潜在客户、增加用户流量、提高用户活跃度、提升品牌形象、增加销售等"]
        }
    }, [index])
    const sellGoodsSrc = React.useMemo(() => {
        if (index === 0) {
            return miniSellGoods_1;
        } else if (index === 1) {
            return miniSellGoods_2;
        } else {
            return miniSellGoods_3;
        }
    }, [index])

    return (
        <div className={styles.spaceSection} style={style}>
            <div className={styles.spaceTitle}>存放内容与商品的空间</div>
            <div className={styles.spaceBtnList}>
                <span className={`${index === 0 && styles.active}`} onClick={() => setIndex(0)}>商家卖货</span>
                <span className={`${index === 1 && styles.active}`} onClick={() => setIndex(1)}>文档管理</span>
                <span className={`${index === 2 && styles.active}`} onClick={() => setIndex(2)}>营销活动</span>
            </div>
            <div className={styles.spaceContent}>
                <div className={styles.spaceContentItem}>
                    <div className={styles.spaceContentItemTitleWrapper}>
                        <div className={styles.spaceContentItemTitle}>{data[0]}</div>
                        <div className={styles.spaceContentItemTips}>
                            <img src={rightIconSrc} alt=""/>
                            {data[1]}
                        </div>
                    </div>
                    <img className={styles.sellGoodPic} src={sellGoodsSrc} alt=""/>
                </div>
            </div>
        </div>
    )
}
const AppDownloadSection: React.FC = () => {
    return (
        <div className={styles.appDownloadSection} id="part4">
            <div className={styles.appDownloadTitle}>免费体验</div>
            <div className={styles.appDownloadContent}>
                <div className={styles.appDownloadContentItem}>
                    <img src={trialVersionCodeSrc} alt=""/>
                    <div className={styles.appDownloadContentItemTitle}>Spacin小程序体验馆</div>
                    <a className={styles.appDownloadContentItemTips} href={downloadLink.trialManagementExclusiveApplet}
                       style={{color: "rgba(102, 194, 185, 1)"}}
                       target={"_blank"}>怎样体验管理专属小程序？</a>
                </div>
                <div className={styles.appDownloadContentItem}>
                    <img src={footerCustomerCode} alt=""/>
                    <div className={styles.appDownloadContentItemTitle}>联系客服，获取体验邀请码</div>
                    <a className={styles.appDownloadContentItemTips} href={downloadLink.managementPlatform}
                       target={"_blank"}>立即了解管理平台功能</a>
                </div>
            </div>
        </div>
    )
}

const Mini: React.FC = () => {
    const location = useLocation();
    const hash = location.hash;

    React.useEffect(() => {
        if (hash) {
            const id = hash.split("#")[1];
            const dom = document.getElementById(id);
            if (dom) {
                dom.scrollIntoView({
                    behavior: "smooth",
                });
            }
        }
    }, [hash])

    return (
        <div className={styles.wrapper}>
            <MiniSection />
            <SpaceSection />
            <AppProcessSection />
            <AppDownloadSection />
        </div>
    );
}

export default Mini;
